// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingResultTable-modulepagination__JqZ_z DocFlowPhaseTable-modulepagination__dqzQr TablePagination-moduleTablePagination__cupJ7";
export { _1 as "pagination" }
